<template>
  <el-dialog
    :visible="visible"
    title="修改密码"
    width="520px"
    :close-on-click-modal="false"
    class="password-dialog"
    @close="close"
    @closed="resetPasswordForm"
  >
    <div class="account-info-title">账号基本信息</div>
    <div class="account-info-list">
      <div
        v-for="item in accountInfoItems"
        :key="item.key"
        class="account-info-item"
      >
        <span class="account-info-label">{{ item.label }}</span>
        <span class="account-info-value">{{ accountInfo[item.key] || '--' }}</span>
      </div>
    </div>
    <el-form
      ref="passwordForm"
      :model="passwordForm"
      :rules="passwordRules"
      label-width="100px"
      class="password-form"
      @submit.native.prevent
    >
      <el-form-item
        label="当前密码"
        prop="current_password"
      >
        <el-input
          v-model="passwordForm.current_password"
          type="password"
          show-password
          autocomplete="current-password"
          placeholder="请输入当前密码"
        />
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="password"
      >
        <el-input
          v-model="passwordForm.password"
          type="password"
          show-password
          autocomplete="new-password"
          maxlength="72"
          placeholder="请输入新密码"
        />
      </el-form-item>
      <el-form-item
        label="确认新密码"
        prop="confirm_password"
      >
        <el-input
          v-model="passwordForm.confirm_password"
          type="password"
          show-password
          autocomplete="new-password"
          maxlength="72"
          placeholder="请再次输入新密码"
        />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="close">取 消</el-button>
      <el-button
        type="primary"
        :loading="changingPassword"
        @click="submit"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changePassword } from '@/service';

export default {
  name: 'ChangePassword',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    accountInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value && new Blob([value]).size > 72) {
        callback(new Error('密码最多72字节，中文通常占3字节，表情通常占4字节'));
      } else {
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入的新密码不一致'));
      } else {
        callback();
      }
    };
    return {
      changingPassword: false,
      passwordForm: {
        current_password: '',
        password: '',
        confirm_password: '',
      },
      passwordRules: {
        current_password: [
          { required: true, message: '请输入当前密码', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' },
        ],
        confirm_password: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' },
        ],
      },
      accountInfoItems: [
        { key: 'username', label: '账户名称' },
        { key: 'company', label: '公司名称' },
        { key: 'email', label: '邮箱' },
        { key: 'contacter_phone', label: '手机号' },
        { key: 'contacter', label: '联系人' },
        { key: 'license_code', label: '信用代码' },
      ],
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.resetPasswordForm();
          this.$nextTick(() => {
            if (this.$refs.passwordForm) this.$refs.passwordForm.clearValidate();
          });
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    resetPasswordForm() {
      this.passwordForm.current_password = '';
      this.passwordForm.password = '';
      this.passwordForm.confirm_password = '';
      this.changingPassword = false;
      if (this.$refs.passwordForm) this.$refs.passwordForm.clearValidate();
    },
    async submit() {
      if (this.changingPassword || !this.$refs.passwordForm) return;
      const valid = await new Promise((resolve) => {
        this.$refs.passwordForm.validate(resolve);
      });
      if (!valid || this.changingPassword) return;
      this.changingPassword = true;
      try {
        const {
          username,
          email,
          contacter_phone,
          contacter,
          company,
          license_code,
        } = this.accountInfo;
        const res = await changePassword({
          username,
          old_password: this.passwordForm.current_password,
          password: this.passwordForm.password,
          email,
          contacter_phone,
          contacter,
          company,
          license_code,
        });
        if (res && res.code === 200) {
          this.$message.success('密码修改成功，请重新登录');
          this.$emit('success');
          this.close();
        } else {
          this.$message.error((res && res.message) || '密码修改失败，请稍后重试');
        }
      } catch (e) {
        this.$message.error(e.message || '密码修改失败，请稍后重试');
      } finally {
        this.changingPassword = false;
      }
    },
  },
};
</script>

<style lang="scss">
.password-dialog {
  .el-dialog__body {
    padding: 20px 30px 4px;
  }
  .account-info-title {
    margin-bottom: 12px;
    color: #303133;
    font-size: 15px;
    font-weight: 500;
  }
  .account-info-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: #f5f7fa;
    border-radius: 4px;
  }
  .account-info-item {
    display: flex;
    min-width: 0;
    padding: 5px 0;
    line-height: 20px;
  }
  .account-info-label {
    flex-shrink: 0;
    width: 70px;
    color: #909399;
    font-size: 13px;
  }
  .account-info-value {
    min-width: 0;
    overflow: hidden;
    color: #606266;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .password-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
  .dialog-footer {
    .el-button {
      min-width: 80px;
    }
  }
}
</style>
